<template>
  <div class="menuFrame">
    <loading :active.sync="isLoading"></loading>

    <div id="track">
      <div class="d-flex justify-content-between">
        <div>
          <a href="/ExhibitorServiceTW/" class="Breadcrumb"> 展覽列表</a><span>/</span> <em name="Exhibition"></em>
          <span>/</span>VIP邀請
        </div>
        <div>
          <span class="bold">登入帳號 :</span>
          <span> {{ UserId }}</span>
        </div>
      </div>
    </div>
    <!-- track end -->
    <!-- article -->

    <div>
      <article>
        <div class="MbDevice">
          <div class="homeLeft">
            <div class="UserAccount ml-1">
              <span class="bold">登入帳號 :</span>
              <span> {{ UserId }}</span>
            </div>
            <hr />
            <div class="expoLogo"><img :src="ExhLogo" width="100%" /></div>
            <div class="expoInfo">
              <p class="bold" name="Exhibition"></p>
              <p>{{ ExhBegin }} - {{ ExhEnd }}</p>
              <p>{{ ExhVenue }}</p>
            </div>
            <p class="clear"></p>
          </div>
        </div>
        <div class="PcDevice">
          <div class="contentBoxStatus py-3">
            <div class="d-flex align-items-center justify-content-around">
              <div
                v-for="(item, index) in MenuInvitation"
                :key="index"
                class="btn btn-white py-2 px-4"
                style="border-radius: 20px; border-color: #d9d9d9"
                @click="InviteLink(item.Url)"
              >
                <span class="font-weight-bold text-primary" style="font-size: 16px" v-if="item.MenuName == 'VIP邀請'">
                  <i class="fas fa-caret-right"></i> {{ item.MenuName }}
                </span>
                <span v-else> <i class="fas fa-caret-right"></i> {{ item.MenuName }} </span>
              </div>
            </div>
          </div>
          <div class="my-3"></div>
        </div>

        <div class="contentBox">
          <!-- left -->
          <div class="proLeft NoShowInMobile align_c">
            <img src="../../../assets/images/iconVip.svg" width="100%" />
          </div>
          <!-- left end -->
          <!-- right -->
          <div class="proRight">
            <div class="MbDevice">
              <div class="d-flex justify-content-between align-items-center">
                <!-- <div>
                  <h1><img src="../../../assets/images/iconVip.svg" width="35px" class="mb-2" /> VIP邀請</h1>
                </div> -->

                <div class="d-flex align-items-center">
                  <div>
                    <img src="@/assets/images/iconVip.svg" width="35px" class="mt-1 mr-1" />
                  </div>
                  <div>
                    <h1>VIP邀請</h1>
                  </div>
                </div>
                <div class="mb-2">
                  <el-dropdown>
                    <span class="el-dropdown-link">
                      <span class="border py-1 px-3">
                        <i class="fas fa-ellipsis-h"></i>
                      </span>
                    </span>
                    <el-dropdown-menu slot="dropdown">
                      <el-dropdown-item v-for="(item, index) in MenuInvitation" :key="index">
                        <span class="MbListGray" @click="InviteLink(item.Url)"> {{ item.MenuName }} </span>
                      </el-dropdown-item>
                    </el-dropdown-menu>
                  </el-dropdown>
                </div>
              </div>
            </div>
            <div class="PcDevice">
              <h1>VIP邀請</h1>
            </div>
            <p class="my-3">&nbsp;</p>
            <p>
              您可以為最重量級的客戶提供專屬VIP證件，受邀客戶即可於展期至現場【VIP服務台】憑名片換證，此證享有全展期免費入場參觀資格。
            </p>
            <p class="my-3">&nbsp;</p>
            <ol class="number">
              <li>邀請額度有限，請斟酌使用</li>
              <li>
                邀請開放至 <span class="red"><span name="CloseDay"></span> 17:00</span> 前
              </li>
              <li>此VIP證限於展期參觀時間進出</li>
            </ol>
            <p class="my-3">&nbsp;</p>
            <div class="grayBG">
              已邀請名額：<span class="red" name="TotalVipRegistered"></span> / <span name="VipInvitationQuota"></span>
              <a
                :href="`https://www.chanchao.com.tw/ExhibitorServiceTW/inviteVIPList?no=${RegNo}`"
                data-fancybox
                data-type="iframe"
                data-options='{"type" : "iframe", "iframe" : {"preload" : false, "css" : {"width" : "1000px"}}}'
                class="ml-1 link iframeFormCard linkstyle"
                >詳細資料 <i class="fas fa-external-link-alt ml-2 text-primary" style="font-size: 15px"></i
              ></a>
            </div>

            <p class="my-3">&nbsp;</p>
            <!-- <a href="javascript:;" @click="bbc">立即邀請</a> -->

            <a
              :href="`https://www.chanchao.com.tw/ExhibitorServiceTW/inviteVIPApply?no=${RegNo}`"
              data-fancybox
              data-type="iframe"
              data-options='{"type" : "iframe", "iframe" : {"preload" : false, "css" : {"width" : "1000px"}}}'
              class="btnStyle iframeForm"
              >立即邀請</a
            >
          </div>
          <p class="clear"></p>
        </div>
      </article>
    </div>
  </div>
</template>

<script>
  import $ from 'jquery'
  import axios from 'axios'

  export default {
    metaInfo() {
      return {
        title: 'VIP邀請 - 展昭參展商管理系統',
      }
    },

    data() {
      return {
        UserId: '',
        RegNo: '',
        VipName: '',
        VipCompany: '',
        lang: 'tw',
        MenuInvitation: [],
        ExhLogo: '',
        ExhBegin: '',
        ExhEnd: '',
        ExhVenue: '',
        eExhVenue: '',
      }
    },

    methods: {
      InviteLink(Url) {
        const vm = this
        if (vm.lang == 'tw') {
          document.location.href = `https://www.chanchao.com.tw/ExhibitorServiceTW/${Url}?no=${vm.RegNo}`
        } else {
          document.location.href = `https://www.chanchao.com.tw/ExhibitorServiceTW/en/${Url}?no=${vm.RegNo}`
        }
      },
    },

    created() {
      const vm = this

      //url取出展碼
      let currentUrl = location.href
      vm.RegNo = currentUrl.split('no=')[1]

      //取得語系

      let lang = 'tw'

      //取得邀請選單
      axios
        .get(`https://www.chanchao.com.tw/apiExhibitors/MenuInvitation/${vm.RegNo}?lang=${vm.lang}`)
        .then((response) => {
          // console.log(response.data.Data)

          vm.MenuInvitation = response.data.Data
        })

      axios.get(`https://www.chanchao.com.tw/apiExhibitors/Exhibition/${vm.RegNo}?lang=${vm.lang}`).then((response) => {
        vm.ExhLogo = `//www.ccie.com.tw/exhibition/images/exlogo/${response.data.Data.ExhLogo}`
        vm.ExhBegin = response.data.Data.ExhBegin
        vm.ExhEnd = response.data.Data.ExhEnd
        vm.ExhVenue = response.data.Data.ExhVenue
        vm.eExhVenue = response.data.Data.eExhVenue
      })

      axios.get(`https://www.chanchao.com.tw/apiExhibitors/UserID`).then((response) => {
        vm.UserId = response.data
      })

      $.getJSON('/apiExhibitors/Exhibition/' + vm.RegNo, { lang: lang }, function (data) {
        // console.log(data.Data)
        $('[name="ExhTime"]').text(data.Data.ExhTime)
        //close day

        // console.log(data.ExhBegin)

        //設定開展前七天
        var CloseDay = new Date(data.Data.ExhBegin)
        // console.log(CloseDay)
        CloseDay.setDate(CloseDay.getDate() - 7)
        $('[name="CloseDay"]').text(formatDate(CloseDay))
        function formatDate(date) {
          var d = new Date(date),
            month = '' + (d.getMonth() + 1),
            day = '' + d.getDate(),
            year = d.getFullYear()
          if (month.length < 2) month = '0' + month
          if (day.length < 2) day = '0' + day
          return [year, month, day].join('/')
        }

        //當前時間 Timestamp
        var currentdate = Date.parse(new Date()).valueOf()
        // console.log(currentdate)

        //開展前七天日期 + 17:00 Timestamp
        var ExhTime = Date.parse(CloseDay) + 61200000
        // console.log(ExhTime)

        if (currentdate > ExhTime) {
          if (lang == 'tw') {
            $('.btnStyle').addClass('btnExpire')
          } else {
            $('.btnStyle').addClass('ebtnExpire')
          }
          $('form').remove()
        }
      })

      //InvTotal
      $.getJSON('/apiExhibitors/ClientVIPTotal_Quota/' + vm.RegNo, function (data) {
        // console.log(data)
        $('[name="VipInvitationQuota"]').text(data.Data.VipInvitationQuota)
        $('[name="TotalVipRegistered"]').text(data.Data.TotalVipRegistered)

        //判斷VIP是否額滿
        if (data.Data.VipInvitationQuota == data.Data.TotalVipRegistered) {
          if (lang == 'tw') {
            $('.btnStyle').addClass('btnFull')
          } else {
            $('.btnStyle').addClass('ebtnFull')
          }
        }
      })
    },
  }
</script>

<style lang="scss">
  a:hover {
    color: #ffffff;
  }

  .Breadcrumb:hover {
    color: #3153f8db;
  }

  .linkstyle:hover {
    color: #0056b3;
  }
</style>
